module.exports = __webpack_public_path__ + "static/media/spot-running.223d39e6.mp4";